function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSensorStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-5",
    width: 21.166666,
    height: 21.166666,
    x: -5.5511151e-17,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#a76d98",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229064,
    y: 277.15622,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.08231481,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-0",
    width: 7.9375,
    height: 7.9375,
    x: 6.6145782,
    y: 282.44788,
    rx: 3.96875,
    ry: 3.96875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSensorStation);
export default __webpack_public_path__ + "static/media/icon-sensor-station.6351251240ceb704f5e860be855d8e95.svg";
export { ForwardRef as ReactComponent };